module.exports = __webpack_public_path__ + "images/symd79d432e5b29b762a4a74ceafa4bc426.png";